/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import {default_enquiry_fields, default_hidden_product_fields} from "@/scripts/util/enquiry-form-fields"
import $ from 'jquery'
import Cookies from 'js-cookie'
import {register} from '@shopify/theme-sections'
import VimeoVideoPlayer from '../modules/vimeoVideoPlayer'
import YouTubeVideoPlayer from '../modules/youtubeVideoPlayer'
import Drift from 'drift-zoom'
import 'slick-carousel'
import {createRoot} from "react-dom/client"
import CountdownTimer from "@/scripts/components/shared/countdown-timer"
import React from "react"
import {getSalesforceEndpoints} from "@/scripts/util/getSalesforceEndpoints"
import {EnquiryForm} from '@/scripts/components/enquiry-form'

// SVGs for enquiry form
import SignPostImage from '../../images/icon-signposts.svg'
import HandMoneyImage from '../../images/icon-hand-money.svg'
import UpgradeImage from '../../images/icon-upgrade.svg'

// Carousel styles, don't need the full carousel JS though.
import '../../styles/components/carousel.scss'
import {findProductSku, findTag} from "@/scripts/util/getProductData"
import {formatMoney} from "@shopify/theme-currency"

const selectors = {
  addToCart: `[data-add-to-cart]`,
  addToCartText: `[data-add-to-cart-text]`,
  comparePrice: `[data-compare-price]`,
  comparePriceText: `[data-compare-text]`,
  originalSelectorId: `[data-product-select]`,
  priceWrapper: `[data-price-wrapper]`,
  productImageWrapper: `[data-product-image-wrapper]`,
  productFeaturedImage: `[data-product-featured-image]`,
  productJson: `[data-product-json]`,
  productMetaJson: `[data-product-meta-json]`,
  productPrice: `[data-product-price]`,
  productThumbs: `[data-product-single-thumbnail]`,
  singleOptionSelector: `[data-single-option-selector]`,
  productZoomImage: `[data-zoom]`,
  addRentProduct: `[data-product-rent]`,
  productImage: `[data-image]`,
  consultantPhoneNumber: `[data-consultant-phone-number]`
}

const cssClasses = {
  activeThumbnail: `active-thumbnail`,
  hide: `hide`
}

function openTab(target) {
  document.querySelectorAll(`.tabcontent`).forEach((tab) => {
    tab.classList.remove(`active`)
  })
  document.getElementById(target).classList.add(`active`)
}

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

export default register(`template-product`, {
  onLoad() {

    this.$container = $(this.container)
    this.namespace = `.${this.id}`

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return
    }

    const product = JSON.parse(
        $(selectors.productJson, this.$container).html()
    )
    const productMeta = JSON.parse($(selectors.productMetaJson, this.$container).html())

    if (document.querySelector(`#countdown_container`)) {
      const countdownContainer = document.querySelector(`#countdown_container`)
      const salesName = countdownContainer.dataset.countdownSaleName
      let countdownCookie = Cookies.get(`countdown_timer_hide_${salesName}`)
      if (countdownCookie === undefined) {
        let countdownRoot = createRoot(countdownContainer)
        countdownRoot.render(
            <CountdownTimer
                timezone={countdownContainer.dataset.timezone}
                endDate={countdownContainer.dataset.endDate}
            />
        )
        let closeButton = document.querySelector(`#close_countdown`)
        if (closeButton) {
          closeButton.addEventListener(`click`, () => {
            document.querySelector(`#countdown_wrapper`).classList.add(`hidden`)
            Cookies.set(`countdown_timer_hide_${salesName}`, salesName)
          })
        }
        document.querySelector(`#countdown_wrapper`).classList.remove(`hidden`)
      }
    }

    const videoPlayVideoID = document.querySelector(`[data-video-id]`)
    /**
     * Create a new script based on the video player
     * Create a new script tag
     */
    const tag = document.createElement(`script`)
    /**
     * Determine which player to use
     */
    const isYoutubePlayer =
        videoPlayVideoID && videoPlayVideoID.dataset.isYoutubePlayer
    const firstScriptTag = document.getElementsByTagName(`script`)[0]

    if (isYoutubePlayer === `true`) {
      tag.src = `https://www.youtube.com/iframe_api`
    } else {
      tag.src = `https://player.vimeo.com/api/player.js`
    }
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    /**
     * Load the play and load the video based on the Video ID
     */
    let youtubePlayer
    let vimeoPlayer
    window.onload = function () {
      if (videoPlayVideoID) {
        if (isYoutubePlayer === `false`) {
          vimeoPlayer = new VimeoVideoPlayer({
            containerId: `vimeo-player`,
            videoId: videoPlayVideoID && videoPlayVideoID.dataset.videoId,
            playButton: `[data-vimeo-play]`,
            stopButton: `[data-vimeo-stop]`,
            customControls: false,
            title: false,
            byline: false,
            portrait: false
          })
        } else if (isYoutubePlayer === `true`) {
          youtubePlayer = new YouTubeVideoPlayer({
            containerId: `yt-player`,
            videoId: videoPlayVideoID && videoPlayVideoID.dataset.videoId
          })
        }
      }
    }

    /**
     * Bind Click Events
     */
    if (vimeoPlayer) {
      $(`[data-vimeo-play]`).on(`click`, () => {
        vimeoPlayer.playVideo()
      })
      $(`[data-vimeo-stop]`).on(`click`, () => {
        vimeoPlayer.pauseVideo()
      })
    }


    $(`#addToCart`).on(`click`, () => {
      let variantID = window.location.pathname.split(`/`).slice(-1)[0]
      let location = window.Shopify.locale === `en` ? `/cart` : `/${window.Shopify.locale}/cart`

      window.jQuery
          .post(`/cart/change.js`, {
            quantity: 0,
            id: variantID
          })
          .done(() => {
            window.location = location
          })
    })
    if (document.getElementById(`current-product-image`)) {
      new Drift(
          document.getElementById(`current-product-image`),
          {
            sourceAttribute: `src`,
            inlinePane: false,
            zoomFactor: 2,
            containInline: true,
            paneContainer: document.getElementById(`image-container`),
            handleTouch: true,
            touchDelay: 300
          }
      )
    }
    document.querySelectorAll(`.thumbnail.image-thumbnail`).forEach((thumbnail) => {
      thumbnail.addEventListener(`click`, (event)=>{
        document.querySelector(`.thumbnail.active`).classList.remove(`active`)
        event.target.classList.add(`active`)
        if (document.querySelector(`.vimeo__wrapper`)) {
          document.querySelector(`.vimeo__wrapper`).classList.add(`hidden`)
          vimeoPlayer.pauseVideo()
        }
        if (document.querySelector(`.yt-player-wrapper`)) {
          document.querySelector(`.yt-player-wrapper`).classList.add(`hidden`)
          youtubePlayer.stopVideo()
        }
        let currentImage = document.getElementById(`current-product-image`)
        currentImage.classList.remove(`hidden`)
        currentImage.src = event.target.src
      })
    })
    if (document.querySelector(`.thumbnail.video-thumbnail`)) {
      document.querySelector(`.thumbnail.video-thumbnail`).addEventListener(`click`, () => {
        document.querySelector(`.thumbnail.active`).classList.remove(`active`)
        document.getElementById(`current-product-image`).classList.add(`hidden`)
        document.querySelector(`.thumbnail.video-thumbnail`).classList.add(`active`)
        if (document.querySelector(`.vimeo__wrapper`)) {
          document.querySelector(`.vimeo__wrapper`).classList.remove(`hidden`)
        } else if (document.querySelector(`.yt-player-wrapper`)) {
          document.querySelector(`.yt-player-wrapper`).classList.remove(`hidden`)
        }
      })
    }
    $(`.thumbnails`).slick(
        {
          arrows: false,
          slidesToShow: 5,
          infinite: false
        }
    )

    // This is done before the slider, to ensure the correct first element is marked as active.
    let first = true
    document.querySelectorAll(`.tablinks`).forEach((link) => {
      if (first) {
        link.classList.add(`active`)
        openTab(link.dataset[`target`])
        first = false
      }
    })
    $(`.tab`).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: false,
      center: true,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 900,
          settings: `unslick`
        }
      ]
    })
    document.querySelectorAll(`.tablinks`).forEach((link) => {
      link.addEventListener(`click`, (event) => {
        document.querySelector(`.tablinks.active`).classList.remove(`active`)
        event.target.classList.add(`active`)
        openTab(event.target.dataset[`target`])
      })
    })

    // New Enquiry Form, REACT component
    const {action_cu_enquire_endpoint, action_new_enquire_endpoint} = getSalesforceEndpoints()
    const enquiryButtonRoot = createRoot(document.getElementById(`product-enquiry-button`))
    const submitEvents = () => {
      window.dataLayer = window.dataLayer || []
      let eventObject = {
        event: `rentalenquiryapplicationsuccess`,
        dealer: ``,
        products: [
          {
            equipmentName: product.title,
            equipmentCategory: findTag(product.tags, `cat:`, true),
            equipmentRefNo: findProductSku(product.variants)
          }
        ],
        totalEquipmentFinance: `${formatMoney(productMeta.rentalprice * 100, window.theme.moneyFormat)}`,
        weeklyRent: productMeta.weeklyrental ? `${formatMoney(productMeta.weeklyrental * 100, window.theme.moneyFormat)}`: ``,
        promoCode: ``,
      }
      const GA_OBJECT = {...eventObject}
      window.dataLayer.push(GA_OBJECT)
    }

    enquiryButtonRoot.render(
        <EnquiryForm
            buttonClassName={`product-button product-button-primary`}
            openButtonText={`Enquire Now`}
            header={`Got a question about this ${product.title}?`}
            fields={default_enquiry_fields}
            hiddenFields={default_hidden_product_fields(product, productMeta)}
            formId={`product-enquiry`}
            actionUri={product.tags.includes(`shopcondition:New`) ? action_new_enquire_endpoint : action_cu_enquire_endpoint}
            content={{
              message: `Fill out the quick form and we'll get back to you within <strong>1 business day</strong>`,
              icons: [
                {
                  image: SignPostImage,
                  text: `<strong>Flexible</strong>, 12 month rental agreement`
                },
                {
                  image: HandMoneyImage,
                  text: `Rental payments are <strong>100% tax deductible</strong>`
                },
                {
                  image: UpgradeImage,
                  text: `Upgrade or buy the equipment <strong>at any time</strong>`
                }
              ]
            }}
            submitEvents={submitEvents}
        />
    )
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    this.$container.off(this.namespace)
  }
})
